

export function vaildateUrl(value) {
  var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
    '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
  return !!pattern.test(value);
}

export function validateIPaddress(ipaddress) {
  return /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(ipaddress)
}

export function readableSize(size) {
  let result = "";
  size = Number(size);
  if(size < 1024){
    result = (size).toFixed(2)+"KB";
  }else if (size < 1024*1024) {
    result = (size/(1024)).toFixed(2)+"GB";
  }else if (size < 1024*1024*1024) {
    result = (size/(1024*1024)).toFixed(2)+"TB";
  }else {
    result = (size/(1024*1024*1024)).toFixed(2)+"PB";
  }
  return result;
}

export const objectToQueryString = (params) => {
  if (!params || Object.keys(params).length === 0) {
    return '';
  }
  
  return '?' + Object.entries(params)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&');
};